import yup from '../../utils/yup';
import createTypedAction from '../createTypedAction';

export const PREFIX = '@@fox/dashboard/';

export const { fetchCheckSheetTasks, FETCH_CHECK_SHEET_TASKS }: any = createTypedAction(
  `${PREFIX}FETCH_CHECK_SHEET_TASKS`,
  ['checkSheetType', yup.string()],
);
export const { fetchCheckSheetTasksSuccess, FETCH_CHECK_SHEET_TASKS_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_CHECK_SHEET_TASKS_SUCCESS`,
  ['tasks', yup.immutable().list()],
  ['checkSheetType', yup.string()],
);
export const { fetchCheckSheetTasksFailed, FETCH_CHECK_SHEET_TASKS_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_CHECK_SHEET_TASKS_FAILED`,
  ['checkSheetType', yup.string()],
);


export const { saveCheckSheet, SAVE_CHECK_SHEET }: any = createTypedAction(
  `${PREFIX}SAVE_CHECK_SHEET`,
  ['checkSheetType', yup.string()],
  ['data', yup.immutable().map()],
  ['deviceId', yup.string().nullable()],

);
export const { saveCheckSheetSuccess, SAVE_CHECK_SHEET_SUCCESS }: any = createTypedAction(
  `${PREFIX}SAVE_CHECK_SHEET_SUCCESS`,
  ['deviceId', yup.string().nullable()],
  ['checkSheetType', yup.string()],
  ['data', yup.immutable().map()],
);
export const { saveCheckSheetFailed, SAVE_CHECK_SHEET_FAILED }: any = createTypedAction(
  `${PREFIX}SAVE_CHECK_SHEET_FAILED`,
  ['deviceId', yup.string().nullable()],
  ['checkSheetType', yup.string()],
);

export const { updateCheckSheet, UPDATE_CHECK_SHEET }: any = createTypedAction(
  `${PREFIX}UPDATE_CHECK_SHEET`,
  ['data', yup.immutable().map()],
  ['deviceId', yup.string().nullable()],
  ['checkSheetType', yup.string()],


);
export const { updateCheckSheetSuccess, UPDATE_CHECK_SHEET_SUCCESS }: any = createTypedAction(
  `${PREFIX}UPDATE_CHECK_SHEET_SUCCESS`,
  ['deviceId', yup.string().nullable()],
  ['data', yup.immutable().map()],
  ['checkSheetType', yup.string()],

);
export const { updateCheckSheetFailed, UPDATE_CHECK_SHEET_FAILED }: any = createTypedAction(
  `${PREFIX}UPDATE_CHECK_SHEET_FAILED`,
  ['deviceId', yup.string().nullable()],
  ['checkSheetType', yup.string()],
);

export const { fetchCheckSheets, FETCH_CHECK_SHEETS }: any = createTypedAction(
  `${PREFIX}FETCH_CHECK_SHEETS`,
  ['checkSheetType', yup.string()],

);
export const { fetchCheckSheetsSuccess, FETCH_CHECK_SHEETS_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_CHECK_SHEETS_SUCCESS`,
  ['checkSheetType', yup.string()],
  ['data', yup.immutable().list()],
);
export const { fetchDeviceCheckSheetsFailed, FETCH_DEVICE_CHECK_SHEETS_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_CHECK_SHEETS_FAILED`,
);

export const { fetchCheckSheet, FETCH_CHECK_SHEET }: any = createTypedAction(
  `${PREFIX}FETCH_CHECK_SHEET`,
  ['checkSheetId', yup.string()],
  ['checkSheetType', yup.string()],
);
export const { fetchCheckSheetSuccess, FETCH_CHECK_SHEET_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_CHECK_SHEET_SUCCESS`,
  ['checkSheetType', yup.string()],
  ['data', yup.immutable().map()],
  ['checkSheetId', yup.string()],
);

export const { updateCheckSheetTypeSuccess, UPDATE_CHECK_SHEET_TYPE_SUCCESS }: any = createTypedAction(
  `${PREFIX}UPDATE_CHECK_SHEET_TYPE_SUCCESS`,
  ['checkSheetType', yup.string()],
  ['checkSheetId', yup.immutable().map()],
);
export const { fetchCheckSheetFailed, FETCH_CHECK_SHEET_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_CHECK_SHEET_FAILED`,
);

export const { downloadFieldReportPdf, DOWNLOAD_FIELD_REPORT_PDF }: any = createTypedAction(
  `${PREFIX}DOWNLOAD_FIELD_REPORT_PDF`,
  ['reportId', yup.string()],
  ['checkSheetType', yup.string()],
  ['deviceTag', yup.string()],
);

export const { downloadFieldReportSummaryPdf, DOWNLOAD_FIELD_REPORT_SUMMARY_PDF }: any = createTypedAction(
  `${PREFIX}DOWNLOAD_FIELD_REPORT_SUMMARY_PDF`,
  ['params', yup.object()],
);
export const { downloadFieldReportSummaryPdfSuccess, DOWNLOAD_FIELD_REPORT_SUMMARY_PDF_SUCCESS }: any = createTypedAction(
  `${PREFIX}DOWNLOAD_FIELD_REPORT_SUMMARY_PDF_SUCCESS`,
);
export const { downloadFieldReportSummaryPdfFailed, DOWNLOAD_FIELD_REPORT_SUMMARY_PDF_FAILED }: any = createTypedAction(
  `${PREFIX}DOWNLOAD_FIELD_REPORT_SUMMARY_PDF_FAILED`,
);

export const { downloadBulkFieldReportPdf, DOWNLOAD_BULK_FIELD_REPORT_PDF }: any = createTypedAction(
  `${PREFIX}DOWNLOAD_BULK_FIELD_REPORT_PDF`,
  ['reportIds', yup.array()],
);
export const { downloadBulkFieldReportPdfSuccess, DOWNLOAD_BULK_FIELD_REPORT_PDF_SUCCESS }: any = createTypedAction(
  `${PREFIX}DOWNLOAD_BULK_FIELD_REPORT_PDF_SUCCESS`,
);
export const { downloadBulkFieldReportPdfFailed, DOWNLOAD_BULK_FIELD_REPORT_PDF_FAILED }: any = createTypedAction(
  `${PREFIX}DOWNLOAD_BULK_FIELD_REPORT_PDF_FAILED`,
);
export const { downloadFieldReportPdfSuccess, DOWNLOAD_FIELD_REPORT_PDF_SUCCESS }: any = createTypedAction(
  `${PREFIX}DOWNLOAD_FIELD_REPORT_PDF_SUCCESS`,
  ['reportId', yup.string()],
);
export const { downloadFieldReportPdfFailed, DOWNLOAD_FIELD_REPORT_PDF_FAILED }: any = createTypedAction(
  `${PREFIX}DOWNLOAD_FIELD_REPORT_PDF_FAILED`,
  ['reportId', yup.string()],
);

export const { openCheckSheet, OPEN_CHECK_SHEET }: any = createTypedAction(
  `${PREFIX}OPEN_CHECK_SHEET`,
  ['checkSheetType', yup.string()],
);

export const { closeCheckSheet, CLOSE_CHECK_SHEET }: any = createTypedAction(
  `${PREFIX}CLOSE_CHECK_SHEET`,
  ['checkSheetType', yup.string()],
);

export const { fetchFieldReports, FETCH_FIELD_REPORTS }: any = createTypedAction(
  `${PREFIX}FETCH_FIELD_REPORTS`,
  ['paginationDetails', yup.object()],
);
export const { fetchFieldReportsSuccess, FETCH_FIELD_REPORTS_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_FIELD_REPORTS_SUCCESS`,
  ['data', yup.immutable().list()],
  ['total', yup.number()],
  ['page', yup.number()],
  ['totalPages', yup.number()],
);
export const { fetchFieldReportsFailed, FETCH_FIELD_REPORTS_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_FIELD_REPORTS_FAILED`,
);

export const { linkDeviceToCheckSheet, LINK_DEVICE_TO_CHECK_SHEET }: any = createTypedAction(
  `${PREFIX}LINK_DEVICE_TO_CHECK_SHEET`,
  ['reportId', yup.string()],
  ['deviceId', yup.string()],
);
export const { linkDeviceToCheckSheetSuccess, LINK_DEVICE_TO_CHECK_SHEET_SUCCESS }: any = createTypedAction(
  `${PREFIX}LINK_DEVICE_TO_CHECK_SHEET_SUCCESS`,
  ['reportId', yup.string()],
  ['deviceId', yup.string()],
);
export const { linkDeviceToCheckSheetFailed, LINK_DEVICE_TO_CHECK_SHEET_FAILED }: any = createTypedAction(
  `${PREFIX}LINK_DEVICE_TO_CHECK_SHEET_FAILED`,
);

export const { updateDeviceLink, UPDATE_DEVICE_LINK }: any = createTypedAction(
  `${PREFIX}UPDATE_DEVICE_LINK`,
  ['reportId', yup.string()],
  ['deviceId', yup.string()],
  ['checkSheetType', yup.string()],
);
export const { updateDeviceLinkSuccess, UPDATE_DEVICE_LINK_SUCCESS }: any = createTypedAction(
  `${PREFIX}UPDATE_DEVICE_LINK_SUCCESS`,
  ['reportId', yup.string()],
  ['deviceId', yup.string()],
);
export const { updateDeviceLinkFailed, UPDATE_DEVICE_LINK_FAILED }: any = createTypedAction(
  `${PREFIX}UPDATE_DEVICE_LINK_FAILED`,
);

export const { fetchReportsCsvExport, FETCH_REPORTS_CSV_EXPORT }: any = createTypedAction(
  `${PREFIX}FETCH_REPORTS_CSV_EXPORT`,
  ['selectedFilters', yup.immutable().map()], // filters from top bar
  ['optionalFilters', yup.immutable().map()], // filter by component or user
);

export const { fetchReportsCsvExportSuccess, FETCH_REPORTS_CSV_EXPORT_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_REPORTS_CSV_EXPORT_SUCCESS`,
);

export const { fetchReportsCsvExportFailed, FETCH_REPORTS_CSV_EXPORT_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_REPORTS_CSV_EXPORT_FAILED`,
  ['err', yup.immutable().map().nullable()]
);
